type TContent = {
  firstStep: {
    header: string
    headline: string
    alertTitle: string
    alertContent: string
    buttonLabel: string
  }
  secondStep: {
    header: string
    headline: string
    sharedInformationTitle: string
    allowedInfoToShareTitle: string
    allowedScopesTitle: string
    alertContent: string
    primaryButtonLabel: string
    secondaryButtonLabel: string
  }
}

const baseContent: TContent = {
  firstStep: {
    header: '',
    headline: '',
    alertTitle: '',
    alertContent: '',
    buttonLabel: '',
  },
  secondStep: {
    header: '',
    headline: '',
    sharedInformationTitle: '',
    allowedInfoToShareTitle: '',
    allowedScopesTitle: '',
    alertContent: '',
    primaryButtonLabel: '',
    secondaryButtonLabel: '',
  },
}

const authorizationContent: TContent = {
  firstStep: {
    header: 'Autenticação via Inter',
    headline: 'Acesse :clientName com os dados de autenticação do Inter',
    alertTitle: 'Atenção aos golpes e fraudes!',
    alertContent:
      'Não acesse QR Codes de outras pessoas. O Inter nunca pedirá códigos ou confirmações de login por chamada.',
    buttonLabel: 'Próximo',
  },
  secondStep: {
    header: 'Autorização',
    headline: 'Verifique o que será compartilhado com :clientName',
    sharedInformationTitle: 'Informações compartilhadas:',
    allowedInfoToShareTitle: 'Informações compartilhadas:',
    allowedScopesTitle: 'Ao autorizar o acesso, :clientName poderá realizar em seu nome:',
    alertContent: 'O :clientName será responsável pelo uso e proteção dos dados recebidos.',
    primaryButtonLabel: 'Confirmar e autorizar',
    secondaryButtonLabel: 'Cancelar',
  },
}

const createAccountContent: TContent = {
  firstStep: {
    header: 'Cadastro via Inter',
    headline: 'Crie seu cadastro :clientName com seus dados do Inter',
    alertTitle: 'Atenção aos golpes e fraudes!',
    alertContent:
      'O Inter nunca pede códigos ou confirmações de login por telefone. Não use QR Codes de outras pessoas.',
    buttonLabel: 'Próximo',
  },
  secondStep: {
    header: 'Cadastro',
    headline: 'Autorize o compartilhamento dos seus dados com o :clientName',
    sharedInformationTitle: 'Dados compartilhados:',
    allowedInfoToShareTitle: 'Dados compartilhados:',
    allowedScopesTitle: 'Ao autorizar o acesso, :clientName poderá realizar em seu nome:',
    alertContent: 'O :clientName será responsável pelo uso e proteção dos dados recebidos.',
    primaryButtonLabel: 'Confirmar e autorizar',
    secondaryButtonLabel: 'Cancelar',
  },
}

const alias = {
  GaloID: 'Clube Atlético Mineiro',
}

const mainContent = {
  GaloID:
    'Autorizo o compartilhamento e utilização do meu :infoList vinculado(s) à minha conta Inter com :clientName, para possibilitar o acesso em :clientName.',
  others:
    'Autorizo o compartilhamento e utilização do meu :infoList vinculado(s) à minha conta Inter com :clientName, para possibilitar o acesso à minha conta em :clientName.',
}

export type { TContent }
export { authorizationContent, createAccountContent, alias, baseContent, mainContent }
